import React from 'react';
import './TableSkeleton.css';

// Varying widths for visual variety per column index
const barWidths = ['70%', '50%', '80%', '40%', '60%', '55%', '75%', '45%', '65%', '50%'];

function TableSkeleton({ columns = 5, rows = 8, hasCheckbox = false, hasActions = true }) {
  const totalCols = (hasCheckbox ? 1 : 0) + columns + (hasActions ? 1 : 0);

  return (
    <>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <tr key={rowIndex} className="table-skeleton-row">
          {hasCheckbox && (
            <td>
              <div className="table-skeleton-checkbox" />
            </td>
          )}
          {Array.from({ length: columns }, (_, colIndex) => (
            <td key={colIndex}>
              <div
                className="table-skeleton-bar"
                style={{ width: barWidths[(rowIndex + colIndex) % barWidths.length] }}
              />
            </td>
          ))}
          {hasActions && (
            <td>
              <div className="table-skeleton-bar" style={{ width: '24px' }} />
            </td>
          )}
        </tr>
      ))}
    </>
  );
}

// Card variant for mobile view
function CardSkeleton({ count = 4 }) {
  return (
    <div className="card-skeleton-list">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="card-skeleton">
          <div className="card-skeleton-header">
            <div className="table-skeleton-bar" style={{ width: '60%' }} />
            <div className="table-skeleton-bar" style={{ width: '24px' }} />
          </div>
          <div className="card-skeleton-body">
            {[1, 2, 3, 4].map(j => (
              <div key={j} className="card-skeleton-field">
                <div className="table-skeleton-bar" style={{ width: '30%' }} />
                <div className="table-skeleton-bar" style={{ width: '50%' }} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export { TableSkeleton, CardSkeleton };
export default TableSkeleton;
